import { Location } from 'history';
import { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router-dom';

// We used this to allow us to upgrade react-router.
// Ideally, we should not use it for new code.
export function WithRouterParams({
  render,
}: {
  render: (params: Record<string, string>, location: Location) => ReactElement;
}): ReactElement {
  const params = useParams();
  const location = useLocation();
  return render(params, location);
}
